import styled from 'styled-components';

import { dynamicViewportHeightStyles } from './reset.styles';

type ViewportPageProps = {
  dataUi?: string;
};

type ViewportFrameProps = {
  dataUi?: string;
  paddingBottomPx?: number;
  paddingLeftPx?: number;
  paddingRightPx?: number;
  paddingTopPx?: number;
};

export const ViewportPage = styled.main
  .withConfig({
    shouldForwardProp: (prop, defaultValidatorFn) =>
      defaultValidatorFn(prop) && prop !== 'dataUi',
  })
  .attrs<ViewportPageProps>(({ dataUi }) => ({
    'data-ui': dataUi,
  }))`
  width: 100%;
  ${dynamicViewportHeightStyles};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.surface.base};
`;

export const ViewportFrame = styled.div
  .withConfig({
    shouldForwardProp: (prop, defaultValidatorFn) =>
      defaultValidatorFn(prop) &&
      ![
        'dataUi',
        'paddingBottomPx',
        'paddingLeftPx',
        'paddingRightPx',
        'paddingTopPx',
      ].includes(prop),
  })
  .attrs<ViewportFrameProps>(({ dataUi }) => ({
    'data-ui': dataUi,
  }))<ViewportFrameProps>`
  width: ${({ theme }) => `${theme.frame.width}px`};
  height: ${({ theme }) => `${theme.frame.height}px`};
  flex-shrink: 0;
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.surface.base};
  padding-top: ${({ paddingTopPx, theme }) =>
    paddingTopPx === undefined
      ? '0px'
      : `max(${theme.scale.px(paddingTopPx)}, env(safe-area-inset-top))`};
  padding-right: ${({ paddingRightPx, theme }) =>
    paddingRightPx === undefined
      ? '0px'
      : `max(${theme.scale.px(paddingRightPx)}, env(safe-area-inset-right))`};
  padding-bottom: ${({ paddingBottomPx, theme }) =>
    paddingBottomPx === undefined
      ? '0px'
      : `max(${theme.scale.px(paddingBottomPx)}, env(safe-area-inset-bottom))`};
  padding-left: ${({ paddingLeftPx, theme }) =>
    paddingLeftPx === undefined
      ? '0px'
      : `max(${theme.scale.px(paddingLeftPx)}, env(safe-area-inset-left))`};
`;
